<div class="container">
  <div class="container__left">
    <div class="left-content">
      <div class="left-error">
        <div class="error-title">{{ title }}</div>
        <div class="error-message">{{ message }}</div>
      </div>
      <div class="left-buttons">
        <button class="htv-selectable" (click)="doBack.emit()">
          {{ 'PAGES.CAST_ERROR.BUTTON.BACK' | translate }}
        </button>
        <div class="separator"></div>
        <button class="htv-selectable htv-focus" (click)="doClose.emit()">
          {{ 'PAGES.CAST_ERROR.BUTTON.CLOSE' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="container__right">
    <div class="right-content">
      <img class="error-img" src="assets/images/googlecast/cast-error.svg" alt="" />
    </div>
  </div>
</div>
